<template>
  <div class="gif-loading" :class="{ 'fade-out': !loading }">
    <!-- <img :src="Logo" class="gif-loading__logo" /> -->
  </div>
</template>

<script setup>
import Logo from '~/assets/images/logo.png'
const props = defineProps({
  loading: { type: Boolean },
})

onMounted(() => {
  setTimeout(() => {
    document.documentElement.style.setProperty('--body-after-display', 'none')
  }, 300)
})
</script>

<style lang="scss" scoped>
.gif-loading {
  height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000000;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.315);
  animation: fadeIn 0.3s ease-in;
  visibility: visible;
  overflow: hidden;
  // background: url(~/assets/images/spa-loading-bg.gif) no-repeat center;
  // background-size: cover;
  &__logo {
    width: 94px;
    animation: shake 4.4s infinite;
    @media screen and (min-width: 1024px) {
      max-width: 50%;
    }
    @keyframes shake {
      0% {
        transform: rotate(20deg);
      }
      25% {
        transform: rotate(10deg);
      }
      50% {
        transform: rotate(-20deg);
      }
      100% {
        transform: rotate(20deg);
      }
    }
  }
}
.fade-out {
  animation: fadeOut 0.3s linear;
  opacity: 0;
  // height: 0;
  visibility: hidden;
  z-index: -1;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    z-index: 1000;
  }

  100% {
    opacity: 0;
    z-index: -1;
  }
}
</style>
<style>
:root {
  --body-after-display: block;
}

body::after {
  display: var(--body-after-display);
  /* animation: shake 4.3s linear; */
}
@keyframes shake {
  0% {
    transform: rotate(25deg);
  }
  25% {
    transform: rotate(-25deg);
  }
  50% {
    transform: rotate(25deg);
  }
  100% {
    transform: rotate(-25deg);
  }
}
</style>
